import React from 'react';
import { StoreConfigProvider } from '@hpstellar/core/context';

import useDeviceInfo from '../../hooks/useDeviceInfo';

const getDeviceBreakpoint = device => {
    switch (true) {
        case device === 'mobile':
            return 'SM';
        case device === 'tablet':
            return 'MD';
        default:
            return 'XXL';
    }
};

export default ({ children }) => {
    //TODO: could potential get more of these context settings from SiteConfig redux store
    const { device } = useDeviceInfo(['device']);
    return (
        <StoreConfigProvider
            config={{
                locale: 'en-US',
                currency: 'USD',
                disclaimer: null,
                preRenderViewport: getDeviceBreakpoint(device),
            }}
        >
            {children}
        </StoreConfigProvider>
    );
};
